export enum FileUploadType {
  Attachment = 1,
  Report,
  UserManual,
  Logo,
}

export const FileUploadTypeName = new Map<number, string>([
  [
    FileUploadType.Attachment,
    $localize`:@@shared.fileUploadType.txtAttachment:attachment`,
  ],
  [FileUploadType.Report, $localize`:@@shared.fileUploadType.txtReport:report`],
  [
    FileUploadType.UserManual,
    $localize`:@@shared.fileUploadType.txtUserManual:user manual`,
  ],
  [FileUploadType.Logo, $localize`:@@shared.fileUploadType.txtLogo:logo`],
]);
